<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Changes Report</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Form -->
        <form :action="backendUrl + '/InsuranceExcelReport/DownloadChangesReport'" method="POST">
            <div class="row align-items-center">
                <div class="col-md-1" style="max-width: fit-content;">Date</div>
                <div class="col-md-2 pl-md-0 ml-2" style="max-width: fit-content;">
                    <select class="custom-select" v-model="date" required>
                        <option value="">-- Please Select --</option>
                        <option v-for="item in dates" :key="item.dateVal" :value="item.dateVal">
                            {{ item.dateDisplay }}
                        </option>
                    </select>
                </div>
                <div class="col-md-2 ml-2">
                    <input type="hidden" name="Date" :value="date" />
                    <button type="submit" class="btn btn-primary"><img width="20px" height="20px" class="mr-1"
                            src="../../assets/excel.png" />Download</button>
                </div>
            </div>
        </form>
        <!-- /Form -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
    data() {
        return {
            date: "",
            dates: []
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        backendUrl() {
            return this.$backendUrl;
        },
    },

    created() {
        if (this.role != "admin") {
            this.$router.replace({ name: "home" });
            return;
        }

        //populate the date for 3 months
        var nearestWedDate = new Date();
        while (nearestWedDate.getDay() != 3) {
            nearestWedDate.setDate(nearestWedDate.getDate() - 1);
        }

        let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const numberOfDays = 12; //3 months
        let count = 1
        do {
            let year = nearestWedDate.getFullYear();
            let monthShort = (nearestWedDate.getMonth() + 1).toString().padStart(2, "0");
            let monthLong = months[monthShort - 1];
            let date = (nearestWedDate.getDate()).toString().padStart(2, "0");
            this.dates.push({
                dateVal: year + "-" + monthShort + "-" + date, dateDisplay: date + " " + monthLong + " " + year
            });
            nearestWedDate.setDate(nearestWedDate.getDate() - 7);
            count++;
        }
        while (count <= numberOfDays);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Insurance/ChangesReport.vue